import { LegacyRef, useEffect } from 'react'
import { ChevronDownIcon } from '@chakra-ui/icons'
import { Button, HStack, MenuButton, Text, Input } from '@chakra-ui/react'
import { Token, MinWidth, Width } from 'types/chakra'
import { IAsyncSelectOption } from 'interfaces/common'

interface IDropdownButtonProps {
  items: IAsyncSelectOption<number>[]
  placeHolder?: string
  isOpen: boolean
  isDisabled?: boolean
  minWidth?: Token<MinWidth | number, 'sizes'>
  width?: Token<Width | number, 'sizes'>
  height?: Token<Width | number, 'sizes'>
  keyword: string
  setKeyword: (keyword: string) => void
  isFocused: boolean
  setIsFocused: (isFocused: boolean) => void
  buttonRef: LegacyRef<HTMLButtonElement>
}

const DropdownButton = (props: IDropdownButtonProps) => {
  const {
    items,
    placeHolder,
    isOpen,
    width,
    height,
    isDisabled,
    keyword,
    setKeyword,
    isFocused,
    setIsFocused,
    buttonRef
  } = props
  const itemTitle = items[0]?.label ?? ''

  useEffect(() => {
    if (isOpen) {
      setIsFocused(true)
    }
  }, [isOpen])

  return (
    <MenuButton
      ref={buttonRef}
      isActive={isOpen}
      display="inline-flex"
      alignItems="center"
      flexWrap="nowrap"
      whiteSpace="nowrap"
      noOfLines={1}
      fontSize={{ base: 'md', lg: 'sm' }}
      color={items?.length > 0 ? 'gray.700' : 'blackAlpha.500'}
      border={'1px solid #E2E8F0'}
      background="white"
      colorScheme="white"
      fontWeight="normal"
      as={Button}
      iconSpacing={5}
      textAlign="left"
      _hover={{ background: 'gray.200' }}
      _focus={{ boxShadow: isFocused ? 'outline' : 'none' }}
      height={height ?? 8}
      width={width}
      isDisabled={isDisabled}
      onClick={() => setIsFocused(true)}
      onMouseEnter={() => setIsFocused(true)}
      onBlur={() => {
        setIsFocused(false)
      }}
    >
      <HStack width="full">
        {isFocused ? (
          <Input
            value={keyword}
            onChange={e => setKeyword && setKeyword(String(e.target.value))}
            autoFocus
            variant="unstyled"
            width="calc(100% - 20px)"
            maxWidth="120px"
            border="none"
            background="transparent"
            fontSize={{ base: 'md', lg: 'sm' }}
            fontWeight={400}
            placeholder={placeHolder ?? ''}
          />
        ) : (
          <HStack width="calc(100% - 20px)">
            <Text
              fontSize={{ base: 'md', lg: 'sm' }}
              fontWeight={400}
              whiteSpace="nowrap"
              overflow="hidden"
              textOverflow="ellipsis"
              display="inline-block"
            >
              {items?.length > 0 ? itemTitle : placeHolder}
            </Text>
            <Text fontSize={{ base: 'md', lg: 'sm' }} fontWeight={400}>
              {items?.length > 1 ? `+${items?.length - 1}` : ''}
            </Text>
          </HStack>
        )}
        <ChevronDownIcon boxSize={5} color="gray.700" />
      </HStack>
    </MenuButton>
  )
}

export default DropdownButton
